export enum StoredDocumentFields {
    STORED_FILE = 'storedFile',
    PROVIDER = 'provider',
    PROVIDER_TYPE = 'providerType',
    DOCUMENT_TYPE = 'documentType',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}
